import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, ListGroup, ListGroupItem } from 'reactstrap';
import { Translate } from '../../helpers/Translate';

export interface SupplyList {
    id: number;
    title: string;
    grade_id: number;
    year_id?: number | string | null;
    fileurl: string;
}

interface SupplyListModalProps {
    isOpen: boolean;
    toggle: () => void;
    supplyLists: SupplyList[];
    studentName?: string;
}

const SupplyListModal: React.FC<SupplyListModalProps> = ({ isOpen, toggle, supplyLists, studentName }) => {
    const t = new Translate();

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                {t.translate("Supply List")} {studentName ? `- ${studentName}` : ""}
            </ModalHeader>
            <ModalBody>
                {supplyLists && supplyLists.length > 0 ? (
                    <ListGroup>
                        {supplyLists.map((list) => (
                            <ListGroupItem
                                key={list.id}
                                className="d-flex justify-content-between align-items-center"
                            >
                                <span>{list.title}</span>
                                <a
                                    className="btn btn-success btn-sm text-light"
                                    href={list.fileurl}
                                    target="_blank"
                                    rel="noreferrer"
                                    download
                                >
                                    {t.translate("Download")}
                                </a>
                            </ListGroupItem>
                        ))}
                    </ListGroup>
                ) : (
                    <p className="text-muted text-center mb-0">
                        {t.translate("No supply list available for this grade level.")}
                    </p>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>{t.translate("Close")}</Button>
            </ModalFooter>
        </Modal>
    );
};

export default SupplyListModal;
